import { render, staticRenderFns } from "./SeoTextBlock.vue?vue&type=template&id=e715d044&scoped=true&"
import script from "./SeoTextBlock.vue?vue&type=script&lang=js&"
export * from "./SeoTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./SeoTextBlock.vue?vue&type=style&index=0&id=e715d044&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e715d044",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e715d044')) {
      api.createRecord('e715d044', component.options)
    } else {
      api.reload('e715d044', component.options)
    }
    module.hot.accept("./SeoTextBlock.vue?vue&type=template&id=e715d044&scoped=true&", function () {
      api.rerender('e715d044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/contents/SeoTextBlock.vue"
export default component.exports